import { PdfTemplate } from "components";
import moment from "moment";
import { CoaGroup, RowExportTypePdf } from "types";
import { convertNumber } from "utils";

export function ExportPdf(params: {
    data: CoaGroup[],
    location: any,
    fillTab: string,
    companyName?: string
}) {
    const sortedData = sortByHierarchy(params.data).filter((item: any) => {
        return params.fillTab !== '' ? params.fillTab.includes(item.group_coa_code) : true
      });

    const columns = [
        { header: 'No', key: 'no', width: 3 },
        { header: 'CHQ', key: 'chq', width: 3 },
        { header: 'ACCOUNT', key: 'coa_code', width: 5 },
        { header: 'NAME', key: 'coa_name', width: 20 },
        { header: 'LINKED', key: 'budget_coa', width: 3 },
        { header: 'LOCATION', key: 'location', width: 5 },
        { header: 'LEVEL', key: 'level', width: 3 },
        { header: 'ACC TYPE', key: 'account_type', width: 10 },
        { header: 'BALANCE', key: 'balance', width: 10 },
    ];

    const dataMap: RowExportTypePdf[] = sortedData.map((item: CoaGroup, index: number) => {
        const textBold = item.account_type !== 'Detail' ? 'bold' : 'normal'

        return {
            no: index + 1,
            chq: {
                text: item.cheque_coa ? 'v' : ''
            },
            coa_code: {
                text: item.coa_code,
                style: {
                    fontWeight: textBold,
                }
            },
            coa_name: {
                text: item.coa_name,
                style: {
                    fontWeight: textBold,
                }
            },
            location: {
                text: params.location.data?.find((loc: any) => loc.value === item.location_id?.toString())?.label || '',
                style: {
                    fontWeight: textBold,
                }
            },
            budget_coa: {
                text: item.budget_coa ? "✔" : ''
            },
            level: {
                text: formatLevel({ headerLevel: item.header_level, coaLevel: item.coa_level }),
                style: { fontWeight: textBold }
            },
            account_type: {
                text: item.account_type_name,
                style: { fontWeight: textBold }
            },
            balance: {
                text: item.opening_balance ? convertNumber(item.opening_balance).intoCurrency : '0',
                style: { textAlign: 'right' , fontWeight: textBold}
            }
        }
    })

    return (
        <PdfTemplate
            dateLabel="As at"
            marginTable={20}
            date={moment().format("DD MMMM YYYY")}
            subtitle={params.companyName}
            module="ACCOUNTS"
            title="Chart of Accounts"
            data={dataMap}
            column={columns}
        />
    )
}


function formatLevel(props: {
    headerLevel: number,
    coaLevel: number
}) {
    if (!props.headerLevel && !props.coaLevel) return '';

    let level = '';

    switch (props.headerLevel) {
        case 1:
            level = 'H';
            break;
        case 2:
            level = 'S';
            break;
        case 3:
            level = 'D';
            break;
        default:
            return props.coaLevel?.toString() || '';
    }

    return `${props.coaLevel ? props.coaLevel + '' : ''}${level}`.trim();
}

function sortByHierarchy(dataList: any, parentId = -1) {
    const parentItems = dataList.filter((item: any) => item.parent_id === parentId);
    parentItems.sort((a: any, b: any) => a.coa_code.localeCompare(b.coa_code));
    
    return parentItems.flatMap((parent : any) => {
      return [parent, ...sortByHierarchy(dataList, parent.coa_id)];
    });
  }